export const ORG_COLS = [
  'Name',
  'Admin First Name',
  'Admin Last Name',
  'Admin Email',
  'Admin Status',
  'Support Admin Email',
  'Support Admin Status',
]

export const ORG_COL_WIDTHS = [300, 250, 250, 400, 250, 400, 250]

export const HEADER_NAME_MAP = {
  'Name': "name",
  'Admin First Name': "first_name",
  'Admin Last Name': "last_name",
  'Admin Email': "email",
  'Admin Status': "status",
  'Support Admin Email': "support_admin_email",
  'Support Admin Status': "support_admin_status",
}

export const SORT_NAME_MAP = {
  'Name': "name",
  'Admin First Name': "first_name",
  'Admin Last Name': "last_name",
  'Admin Email': "email",
  'Admin Status': "status",
  'Support Admin Email': "support_admin_email",
  'Support Admin Status': "support_admin_status",
}